import React, {useState} from "react";
import "../templates/jurisdiction.css";
import JurisdictionFormFields from "./JurisdictionFormFields";

const AddJurisdictionForm = () => {
    const [crumbs] = useState([
            {content: "Home", url: "/home"},
            {content: "Jurisdictions", url: "/jurisdictions"},
            {content: "Add Jurisdiction", url: ""}
        ]
    )

    return (
        <>
            <JurisdictionFormFields crumbs={crumbs} title={"Add Jurisdiction"} btnText={"Create"}
               />
        </>
    )
}

export default AddJurisdictionForm;



